module.exports = __webpack_public_path__ + "static/media/dao-tuan-viet.202bca02.png";